import { useMutation } from '@tanstack/react-query';
import { ApiError, adminApi } from '../lib/api';

export class RateLimitError extends Error {
  constructor() {
    super('Rate limit: 5 impersonations/hour');
    this.name = 'RateLimitError';
  }
}

export function useImpersonate() {
  return useMutation({
    mutationFn: async (userId: string) => {
      try {
        return await adminApi.impersonate(userId);
      } catch (err) {
        if (err instanceof ApiError && err.status === 429) {
          throw new RateLimitError();
        }
        throw err;
      }
    },
  });
}
